import React from "react";
import Box from "@mui/material/Box/Box";
import { theme } from "../../special/genie-theme/genie-theme";

interface GenieStickyHeaderProps {
  children: React.ReactNode;
}

function GenieStickyHeader({ children }: GenieStickyHeaderProps) {
  return (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      py={2}
      borderBottom={1}
      sx={{
        backgroundColor: theme.palette.common.white,
        position: "sticky",
        top: 0,
        borderColor: "grey.300",
        zIndex: 1111,
      }}
    >
      {children}
    </Box>
  );
}

export default GenieStickyHeader;
